export default __webpack_public_path__ + "static/media/card5.6fc9aef6.png";